<div class="m-accordion"
     :class="[
            'm--is-' + propSkin,
            {
                'm--is-closed': !propOpen,
                'm--is-open': propOpen,
                'm--is-disabled': propDisabled,
                'm--has-icon-left': isIconPositionLeft,
                'm--has-icon-large': isIconSizeLarge,
                'm--is-empty-content': !hasContent()
            }
        ]">
    <div :id="propId"
         class="m-accordion__header"
         :class="{
            'm--has-padding': paddingHeader && padding
         }"
         role="button"
         :aria-expanded="propOpen ? 'true' : 'false'"
         :aria-controls="idBodyWrap"
         :tabindex="headerTabindex"
         :aria-disabled="propDisabled"
         ref="accordionHeader"
         @click="toggleAccordion"
         @keyup.self.enter="toggleAccordion"
         @keydown.space="toggleAccordion">
        <div class="m-accordion__header-content">
            <slot name="header" />
        </div>
        <m-plus v-if="hasContent()"
                class="m-accordion__header-icon"
                :class="{
                    'm--is-left': isIconPositionLeft
                }"
                :border="hasIconBorder"
                :large="isIconSizeLarge"
                :open="propOpen"
                :skin="plusSkin"
                aria-hidden="true" />
    </div>
    <m-accordion-transition v-if="$slots.default"
                            :height-delta="deltaHeight">
        <!-- Replace v-if / else with keep-alive. -->
        <template v-if="!keepContentAlive">
            <div v-if="propOpen"
                 :id="idBodyWrap"
                 class="m-accordion__body-wrap"
                 role="region"
                 :aria-labelledby="propId">
                <div class="m-accordion__body"
                     :class="classBody">
                    <slot />
                </div>
            </div>
        </template>
        <template v-else>
            <div v-show="propOpen"
                 :id="idBodyWrap"
                 class="m-accordion__body-wrap"
                 role="region"
                 :aria-labelledby="propId">
                <div class="m-accordion__body"
                     :class="classBody">
                    <slot />
                </div>
            </div>
        </template>
    </m-accordion-transition>
</div>
